export default "__VITE_ASSET__3fb978fe__"